import { baseURL } from "./tanzib";
import { get, post, put } from "../lib/apiHelpers";
import { ApiError } from "src/types";
import {
  OtpData,
  PhoneLoginData,
  RefreshAccessType,
  UsernameUpdate,
} from "src/types/api/auth.types";
import translation from "../data/fa-IR.json";

//GETTING OTP WITH PHONE
export function phoneLogin(userdata: PhoneLoginData) {
  return post(`${baseURL}/login`, userdata);
}

//////////////////////////////////////////////
//GETTING TOKEN WITH GOOGLE
export function googleLogin() {
  return get(`${baseURL}/auth/google?platform=web`);
}

/////////////////////////////////////////////
//SENDING OTP
export function sendOtpToApi(otp: OtpData) {
  return post(`${baseURL}/otp`, otp);
}

/////////////////////////////////////////////
//GETTING USER DETAILS
export function getUser() {
  return get(`${baseURL}/user`);
}

//UPDATING USERNAME
export function updateUsername(username: UsernameUpdate) {
  return put(`${baseURL}/user`, username);
}

//Refresh access Token
export async function refreshAccessToken(): Promise<string> {
  try {
    const storedAuth = localStorage.getItem("auth");
    const refreshData: RefreshAccessType = {
      refresh: storedAuth ? JSON.parse(storedAuth).refresh : null,
    };

    if (!refreshData.refresh) {
      window.location.href = "/login";
      throw new Error("No refresh token — redirecting to login");
    }

    const res = await fetch(`${baseURL}/refresh`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(refreshData),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      localStorage.removeItem("auth");
      window.location.href = "/login";

      throw new Error("No refresh token — redirecting to login");
    }

    localStorage.setItem(
      "auth",
      JSON.stringify({
        access: data.data.access,
        refresh: data.data.refresh,
      })
    );

    return data.data.access;
  } catch (error: any) {
    const fallback: ApiError = {
      title: error?.title || translation.Global.ServerError,
      detail: error?.detail || translation.Global.ServerErrorDetail,
      status: error?.status || 500,
    };

    throw fallback;
  }
}
